import { Spacer } from '../../parts/Spacer';

export const FormValidationMessage: React.FC<{
  validateMessage: string;
}> = ({ validateMessage }) =>
  validateMessage ? (
    <div>
      <Spacer spacing={1} />
      <div className="text-base2 font-bold leading-[1.4] text-caution-primary">
        {validateMessage}
      </div>
    </div>
  ) : null;
